export default function (context) {
    context.commit('data', {
        add_payment: true,
        tab: 'payment'
    });
    context.dispatch('payment/create');
}